// Add dph to given price
export const addDPH = (priceWithoutDPH: number, rate: number = 21): number => {
  const priceWithDPH = priceWithoutDPH * (1 + rate / 100);
  return Math.round(priceWithDPH * 100) / 100;
};
// Extract dph from price
export const getDPHAmount = (priceWithoutDPH: number, rate: number = 21): number => {
  return priceWithoutDPH * (rate / 100);
};